import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { TGetInvoiceTemplateByIdResponse } from "./getInvoiceTemplateById.schema";

/**
 * @description
 * Fetches a single Invoice Template by its ID.
 * Sends GET request to la-forge route: GET /api/invoices/templates/:id
 *
 * @param axios - injected axios instance from AbstractApiClient
 * @param id - invoice template ID to fetch
 * @returns full invoice template data
 */
export const getInvoiceTemplateById =
  (axios: IAxiosInstance) =>
  async (id: string): Promise<TGetInvoiceTemplateByIdResponse> => {
    const response = await axios.noRetry.get(`/api/invoices/templates/${id}`);
    const resData = response.data;

    if (resData?.success) {
      return resData.data;
    }

    throw new Error(resData?.error || "Error fetching invoice template");
  };
